import React, { useContext } from 'react';
import NotificationContext from './Components/Notifications/NotificationProvider';
import NotificationContextType from './Components/Notifications/NotificationContextType';
import { useTranslation } from 'react-i18next'; // Import the translation hook

export interface WithNotificationsProps {
  notifications: {
    showNotification: NotificationContextType['showNotification'];
    setNotifications: NotificationContextType['setNotifications'];
  };
  t: (key: string) => string; // Add t function to the props
}

function withNotifications<T>(Component: React.ComponentType<T & WithNotificationsProps>) {
  return (props: Omit<T, keyof WithNotificationsProps>) => {
    const context = useContext(NotificationContext);
    const { t } = useTranslation(); // Get the translation function

    if (!context) {
      throw new Error('withNotifications must be used within a NotificationProvider');
    }

    const notifications = {
      showNotification: context.showNotification,
      setNotifications: context.setNotifications,
    };

    // Pass both notifications and t (translation function) to the wrapped component
    return <Component {...(props as T)} notifications={notifications} t={t} />;
  };
}

export default withNotifications;

// import React, { useContext } from 'react';
// import NotificationContext from './Components/Notifications/NotificationProvider';
// import NotificationContextType from './Components/Notifications/NotificationContextType';


// export interface WithNotificationsProps {
//     notifications: {
//       showNotification: NotificationContextType['showNotification'];
//       setNotifications: NotificationContextType['setNotifications'];
//     };
//   }  

// function withNotifications<T>(Component: React.ComponentType<T & WithNotificationsProps>) {
//     return (props: Omit<T, keyof WithNotificationsProps>) => {
//       const context = React.useContext(NotificationContext);
  
//       if (!context) {
//         throw new Error('withNotifications must be used within a NotificationProvider');
//       }
  
//       const notifications = {
//         showNotification: context.showNotification,
//         setNotifications: context.setNotifications,
//       };
  
//       // Pasar la prop notifications al componente envuelto
//       return <Component {...(props as T)} notifications={notifications} />;
//     };
//   }
  

// export default withNotifications;
